//TODO - might need decodedCookie = decodeURIComponent(document.cookie);

const cookie_read =(name)=>{
    return document.cookie.split(';').map((s)=>s.split('=')).find((n)=>n[0].trim() ==name)[1].trim()
}

export {cookie_read }